<template>
	<div>
		<BaseHeader />
		<div class="container_wrap">
			<form name="go_event">
				<BaseTitle class="basic" :title="pageName" />
				<div class="container">
					<BaseAccordion :items="faqList" name="faq">
						<template #title="{ item }">
							<p>{{ item.title }}</p>
							<button type="button" class="btnI"></button>
						</template>
						<template #content="{ item }">
							<div class="content_inner" v-html="item.bodyText"></div>
						</template>
					</BaseAccordion>
				</div>
				<div class="note faq_info">
					<template v-for="(info, idx) in infoList" :key="idx">
						<p>{{ info.title }}</p>
						<ul>
							<template v-for="(content, idx) in info.content" :key="idx">
								<li v-if="content" v-html="content"></li>
							</template>
						</ul>
						<br />
					</template>
				</div>
			</form>
			<div class="faq_footer">
				<span>
					기타 시스템 및 버스 관련 문의는 위즈돔 컨텍센터<br />
					<a href="tel:1599-9360">1599-9360</a>로 부탁드립니다.
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import BaseHeader from '@/components/Base/BaseHeader.vue';
import BaseTitle from '@/components/Base/BaseTitle.vue';
import BaseAccordion from '@/components/Base/BaseAccordion.vue';
import { onBeforeMount } from '@vue/runtime-core';

export default {
	name: 'FAQ',
	components: {
		BaseHeader,
		BaseTitle,
		// BaseInfo,
		BaseAccordion,
	},
	props: {
		page: {
			type: String,
		},
		pageName: {
			type: String,
		},
	},
	setup() {
		const store = useStore();
		const infoList = ref([
			{
				title: '탑승 에티켓',
				content: [
					'좌석 등받이는 뒷좌석 승객을 배려하여 살짝만 젖혀주세요!',
					'차내에서는 음식물 취식물 취식은 절대금지!',
					'하차 시 두고 내리는 물건은 없는지 한번 더 확인!',
					'차량내 애완견 동반 탑승은 불가합니다.',
				],
			},
			{
				title:
					'다음과 같은 운영사/운행사 과실이 인정되는 경우 전액 환불 처리해드립니다.',
				content: [
					'시스템오류(예약 및 취소), 미정차, 미운행, 운행 중 사고, 고의운행지연이 발생한 경우<br/> 단, 천재지변(교통상황 및 기상상황 등)의 경우 면책한다.',
				],
			},
			{
				title: '서비스 공급자 면책사항',
				content: [
					'천재지변 또는 기타 불가항력적인 사태로 인한 불의의 피해',
					'운행도중 승객이 무단 이탈하여 초래한 피해',
					'승객의 과실 또는 태만으로 인한 손해',
					'승객이 약관 및 관련한 법규위반으로 인한 피해 및 손해',
					'휴대화물 및 수화물 분실',
				],
			},
		]);
		const faqList = ref([]);
		const getFAQList = async () => {
			const result = await store.dispatch('common/FETCH_FAQ_LIST', {
				bbsTypeCode: 'BBS-FAQ',
				talkTypeCode: 'TKT-POST',
				displayYn: true,
				sort: 'displayOrder',
				order: 'asc',
			});
			faqList.value = result;
		};
		onBeforeMount(() => {
			getFAQList();
		});

		return {
			faqList,
			infoList,
		};
	},
};
</script>
